import { isPlainObject, mapValues, pickBy } from 'lodash';

export default (value, predicate) =>
  (function pickDeep(value) {
    return isPlainObject(value)
      ? mapValues(pickBy(value, predicate), pickDeep)
      : value;
  })(value);
